<script setup lang="ts">
  interface Emits {
    (event: "update:isOn", isOn: boolean): void;
    (event: "click", e: any): void;
  }
  interface Props {
    isOn: boolean;
    imgOn: string;
    imgOff: string;
    width: number;
    disabled?: boolean;
  }
  const props = defineProps<Props>();
  const emit = defineEmits<Emits>();
  const click = (event: any) => {
    if (!props.disabled) {
      emit("update:isOn", !props.isOn);
      emit("click", event);
    }
  };
  const padding = 8;
</script>

<template>
  <div class="switch" :class="disabled ? '' : 'cursor'" @click="click">
    <div class="container">
      <AtomsSvgIcon
        v-if="isOn"
        class="icon"
        :width="width - padding"
        :height="width - padding"
        :img-path="imgOn"
      />
      <AtomsSvgIcon
        v-else
        class="icon"
        :width="width - padding"
        :height="width - padding"
        :img-path="imgOff"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .cursor {
    cursor: pointer;
  }
  .switch {
    width: v-bind(width);
    height: v-bind(width);
    border-radius: 50%;
    background-color: rgba(54, 30, 255, 0.3) !important;
  }
  .container {
    width: 100%;
    height: 100%;
    position: relative;
  }
  .icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
</style>
